module.exports = __webpack_public_path__ + "static/media/Roboticon01.21c0dc28.png";